import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import CalendarTermPicker from './CalendarTermPicker';

loadDOMComponent({
	selector: 'react-calendar-term-picker',
	callback: ({ container }) => {
		// const id = container.getAttribute('data-target-hidden-id');
		const inputPlaceholder = container.getAttribute('inputPlaceholder');
		const inputLabel = container.getAttribute('inputLabel');
		const htmlId = container.getAttribute('htmlId');

		ReactDOM.render(
			<AppContextProvider>
				<CalendarTermPicker
					inputLabel={inputLabel}
					inputPlaceholder={inputPlaceholder}
					htmlId={htmlId}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
